<section class="list-section keywords-list-section-2 " [ngClass]="{ 'stripMarginAddedKeywordPage': stripMargin,'subscribe-strip-margin-keywords':  shouldShowTrialBanner }">
  <div class="container-fluid">
    <nav aria-label="breadcrumb" class="breadcrumb-section d-flex justify-content-between mb-2">
      <ol class="breadcrumb align-items-center">

        <li class="breadcrumb-item d-flex align-items-center">
          <a class="btn quinary-btn" href="">Home </a>
          <i class=" breadcrumb-arrow-right sprite-img-list "></i>
        </li>
        <li class="breadcrumb-item d-flex align-items-center">
          <a class="btn quinary-btn" href="/all-tenders/active">Indian Government Tenders </a>
          <i class=" breadcrumb-arrow-right sprite-img-list "></i>
        </li>
        <li class="breadcrumb-item active">{{paramsData | titlecase}}</li>
      </ol>
    </nav>
    <h1 class="section-heading-3 mt-3">Indian Tenders By {{paramsData | titlecase}} </h1>

    <div class="keywords-group">


      <div class="alphabet-filter-list">
        <ul>
          <li *ngFor="let alphabet of alphabets">
            <a (click)="scrollToSection(alphabet); setActiveLink(alphabet)"
              [ngClass]="{'active': isActiveLink == alphabet}" href="javascript:void(0)">{{ alphabet }}</a>
          </li>
        </ul>
      </div>

      <div class="keywords-list-section">
        <ng-container *ngFor="let stateGroup of getGroupedStatesEntries()">
          <ul
            *ngIf="paramsData === 'states' || paramsData === 'cities' || paramsData === 'authorities' || paramsData === 'categories' || paramsData === 'procurement' || paramsData === 'keywords'"
            id="section{{stateGroup.key}}" [class.active]="isActiveLink === stateGroup.key">
            <li *ngFor="let item of stateGroup.value">
              <span>
                <!-- Use (click) to handle navigation programmatically -->
                <a href="/{{item.link}}-tenders/active" (click)="navigate($event, item.link)">{{ item.name }} Tenders ({{
                  item.count }})</a>
              </span>
            </li>
          </ul>
        </ng-container>
      </div>

    </div>
  </div>
</section>